import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";

// GSAP for the TASMA logo's watching eyes (the brand's one animation in the hub). Registered once, here.
gsap.registerPlugin(useGSAP);

export { gsap, useGSAP };
